import { FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  usePatientEmailMessagePreview,
  type PatientEmailHistoryItem,
} from '@/hooks/usePatientEmailHistory';
import { patientEmailTypeLabel } from '@/lib/emailHistory';

export function PatientEmailTypeBadge({ emailType }: { emailType: string }) {
  const { t } = useTranslation();
  return (
    <span className="inline-flex items-center gap-1 rounded bg-ds-neutral-tint px-2 py-0.5 text-[11px] font-medium text-ds-muted">
      <FileText className="h-3 w-3" />
      {patientEmailTypeLabel(emailType, t)}
    </span>
  );
}

export function PatientEmailHistoryDetails({
  email,
  timestamp,
}: {
  email: Pick<PatientEmailHistoryItem, 'subject' | 'error_message' | 'provider_message_id'>;
  timestamp: string;
}) {
  const { t } = useTranslation();
  const { data: stored } = usePatientEmailMessagePreview(email.provider_message_id);
  const subject = email.subject || stored?.subject || '';
  return (
    <div className="space-y-1 rounded-md bg-ds-sunk p-3 text-xs text-ds-text-2">
      {subject ? (
        <div>
          {t('email.subject', 'Emne')}: {subject}
        </div>
      ) : null}
      <div>
        {t('email.sent_at', 'Sendt')}: {timestamp}
      </div>
      {stored?.body ? <div className="whitespace-pre-wrap">{stored.body}</div> : null}
      {email.error_message ? (
        <div className="rounded bg-ds-red-tint p-2 text-ds-red-ink ring-1 ring-ds-red-line">
          {t('email.error', 'Fejl')}: {email.error_message}
        </div>
      ) : null}
      {email.provider_message_id ? (
        <div className="font-mono text-[10px] text-ds-placeholder">
          {t('email.message_id', 'Message-ID')}: {email.provider_message_id}
        </div>
      ) : null}
    </div>
  );
}
